function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Groupe_3230",
  "data-name": "Groupe 3230",
  transform: "translate(-39.592)"
}, React.createElement("path", {
  id: "Trac\\xE9_1882",
  "data-name": "Trac\\xE9 1882",
  d: "M57.885,221.248,39.592,255.713,56.2,254.179l8.04,14.619,18.293-34.465Z",
  transform: "translate(0 -185.033)",
  fill: "#fdd44f"
}), React.createElement("g", {
  id: "Groupe_3229",
  "data-name": "Groupe 3229",
  transform: "translate(67.452 36.215)"
}, React.createElement("path", {
  id: "Trac\\xE9_1883",
  "data-name": "Trac\\xE9 1883",
  d: "M234.452,221.248l18.293,34.465-16.612-1.535-8.04,14.619L209.8,234.332Z",
  transform: "translate(-209.8 -221.248)",
  fill: "#fdd44f"
})), React.createElement("circle", {
  id: "Ellipse_256",
  "data-name": "Ellipse 256",
  cx: 30.566,
  cy: 30.566,
  r: 30.566,
  transform: "translate(44.429 0)",
  fill: "#ce162b"
}), React.createElement("path", {
  id: "Trac\\xE9_1884",
  "data-name": "Trac\\xE9 1884",
  d: "M144.4,97.074a21.817,21.817,0,1,1,21.818-21.816A21.844,21.844,0,0,1,144.4,97.074Z",
  transform: "translate(-69.408 -44.693)",
  fill: "#ff8e70"
}), React.createElement("path", {
  id: "Trac\\xE9_1885",
  "data-name": "Trac\\xE9 1885",
  d: "M186.075,100.678H175.463l-3.282-10.093a1.409,1.409,0,0,0-2.679,0l-3.279,10.093H155.612a1.408,1.408,0,0,0-.828,2.548l8.585,6.238-3.279,10.093a1.409,1.409,0,0,0,2.168,1.574l8.585-6.238,8.585,6.238a1.409,1.409,0,0,0,2.168-1.574l-3.279-10.093,8.585-6.238A1.409,1.409,0,0,0,186.075,100.678Z",
  transform: "translate(-95.849 -74.944)",
  fill: "#fdd44f"
}));

var SvgPrize = function SvgPrize(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 70.806,
    height: 83.764,
    viewBox: "0 0 70.806 83.764",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPrize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/prize.86bdbe2a.svg";
export { ForwardRef as ReactComponent };